import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  searchFilterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 24px',
    margin: '16px 0px 24px',
    height: '100%',
    border: 'none',
  },
  searchWrap: {
    width: '100%',
  },
  sublocationName: { backgroundColor: `${theme?.palette?.grey[900_2]}` },
  assetForm: { border: `1px solid ${theme?.palette?.grey[900]}` },
  reportMachineBtn: {
    padding: '8px 14px 8px 14px',
    color: `${theme?.palette.secondary.main}`,
    backgroundColor: `${theme?.palette?.grey[100]}`,
    '&:hover': {
      color: `${theme?.palette?.common?.white}`,
    },
  },
  moneyInput: { color: `${theme?.palette?.common?.black}`, opacity: 0.6 },
  accordionColumns: { backgroundColor: `${theme?.palette?.grey[900_2]}` },
  summaryBackground: { backgroundColor: `${theme?.palette?.grey[900_2]}` },
  collectionFieldItem: {
    '& .Mui-disabled': {
      '&.Mui-error': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.error.main,
        },
      },
    },
  },
  accordion: {
    '& .Mui-expanded': {
      margin: 0,
    },
  },
  playcardTitleContainer: {
    backgroundColor: theme.palette.grey[900_2],
    padding: 10,
  },
  playcardSaleFromCash: {
    padding: '12px 0px 8px 37px',
  },
  playcardMeterTitle: {
    padding: '12px 10px 8px 0px',
  },
  playcardMeterTotalSales: {
    padding: '0px 10px 8px 37px',
  },
  labelClass: {
    [theme.breakpoints.down('lg')]: {
      [theme.breakpoints.up('md')]: {
        '& .MuiFormLabel-root.MuiInputLabel-root': {
          marginTop: '-12px',
        },
      },
    },
  },
  compactMetersContainer: {
    gap: 0,
    '& > *:not(:first-child) $compactMeterRow': {
      borderTop: 0,
    },
  },
  compactMeterRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 0,
    width: '100%',
    minWidth: 0,
    border: '1.5px solid #333333',
    borderRadius: 0,
    padding: 0,
    backgroundColor: theme.palette.common.white,
    overflowX: 'auto',
  },
  compactMeterLabelWrap: {
    flex: '0 0 110px',
    minWidth: 110,
    padding: '0 6px',
    borderRight: '1.5px solid #333333',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 2,
  },
  compactMeterLabel: {
    fontSize: '0.84rem',
    lineHeight: 1.25,
    fontWeight: 600,
    wordBreak: 'break-word',
  },
  compactMeterGrid: {
    flex: 1,
    minWidth: 0,
    display: 'grid !important',
    alignItems: 'stretch',
    gap: 0,
    '& > div': {
      minHeight: 86,
      minWidth: 95,
      width: '100%',
      borderLeft: '1.5px solid #333333',
      padding: '10px 6px 8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    },
    '& > [class*=MuiGrid]': {
      minHeight: 86,
      width: '100%',
      borderLeft: '1.5px solid #333333',
      padding: '10px 6px 8px !important',
      display: 'block',
      boxSizing: 'border-box',
    },
    '& .MuiFormControl-root': {
      marginTop: 4,
      width: '100%',
    },
    '& .MuiOutlinedInput-root': {
      minHeight: 46,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2f2f2f !important',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#333333 !important',
    },
    '& .MuiOutlinedInput-input': {
      fontSize: 14,
      fontWeight: 600,
      padding: '10px 8px !important',
      textAlign: 'left',
    },
    '& .MuiOutlinedInput-adornedStart .MuiOutlinedInput-input': {
      paddingLeft: '2px !important',
    },
    '& .MuiOutlinedInput-adornedEnd .MuiOutlinedInput-input': {
      paddingRight: '32px !important',
    },
    '& .MuiOutlinedInput-adornedStart.MuiOutlinedInput-adornedEnd .MuiOutlinedInput-input': {
      paddingRight: '36px !important',
    },
    '& .MuiInputAdornment-positionStart': {
      marginRight: 4,
      '& .MuiTypography-root': {
        fontSize: 14,
        fontWeight: 600,
      },
    },
    '& .MuiInputAdornment-positionEnd': {
      marginLeft: 2,
      '& .MuiSvgIcon-root': {
        fontSize: 18,
      },
    },
    '& .MuiFormLabel-root.MuiInputLabel-root': {
      fontSize: 10,
      transform: 'translate(10px, 11px) scale(1) !important',
      lineHeight: 1.1,
      color: '#1f1f1f !important',
      backgroundColor: theme.palette.common.white,
      padding: '0 2px',
    },
    '& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-shrink': {
      transform: 'translate(10px, 4px) scale(0.75) !important',
      color: '#333333 !important',
    },
  },
  reconciliationContentLayout: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    width: '100%',
  },
  reconciliationGridSection: {
    flex: 1,
    minWidth: 0,
    overflowX: 'auto',
  },
  reconciliationSummaryPanel: {
    position: 'sticky',
    top: 84,
    width: 280,
    minWidth: 200,
    maxWidth: 300,
    flexShrink: 0,
    alignSelf: 'flex-start',
    background: theme.palette.common.white,
    border: 'none',
    padding: '6px',
  },
  reconciliationSummaryActionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: 8,
    gap: 8,
  },
  comment: {
    backgroundColor: `${theme?.palette?.grey[100_1]}`,
    borderRadius: 0,
  },
  commentBox: { maxWidth: '340px' },
  listIcon: {
    color: theme.palette.primary.main,
    width: '0.5rem',
    height: '0.5rem',
  },
  displayCommentContainer: { color: theme.palette.primary.main },
  commentListBox: {
    padding: '18px 24px 0px 24px',
    background: theme.palette.primary.lighter,
    border: `1px solid ${theme.palette.primary.light}`,
    borderRadius: 8,
    boxShadow: '0px 1px 4px rgba(100, 116, 139, 0.12)',
    '& .MuiListItem-root': { padding: 0 },
    '& .MuiListItemText-root': { margin: 0 },
  },
  commentIcon: {
    color: theme.palette.common.white,
    padding: 4,
    background: theme.palette.primary.main,
    borderRadius: 4,
  },
  locationHeaderSubmissionDate: {
    minWidth: 170,
  },
  // initialTableCheckbox: {
  //   '& th[class*=MuiTableCell-head]': {
  //     '&:first-of-type': {
  //       padding: '10px 0',
  //     },
  //   },
  //   '& td[class*=MuiTableCell-body]': {
  //     '&:first-of-type': {
  //       padding: '10px 0',
  //     },
  //   },
  // },
  addMissingAssetsContainer: {
    padding: '10px 10px 10px 25px',
    '& .MuiFormLabel-root.MuiInputLabel-root': {
      lineHeight: '1.4375em !important',
    },
    '& .MuiButtonBase-root.MuiButton-root': {
      padding: '16px 24px',
    },
  },
  // Independent Rep
  independentRepContainer: {
    backgroundColor: theme.palette.grey[200],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    overflow: 'hidden',
    '& .MuiFormLabel-root.MuiInputLabel-root': {
      lineHeight: '1.4375em !important',
    },
    '& .MuiButtonBase-root.MuiButton-root': {
      padding: '10px 16px',
    },
  },
  independentRepTitle: {
    backgroundColor: theme.palette.grey[300],
    padding: '8px 10px',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  independentRepForm: {
    padding: '8px 10px',
  },
  warningListBox: {
    padding: '18px 24px 0px 24px',
    background: 'rgba(255, 186, 0, 0.05)',
    border: '1px solid rgba(255, 186, 0, 0.05)',
    borderRadius: 8,
    boxShadow: '0px 1px 4px rgba(100, 116, 139, 0.12)',
    '& .MuiListItem-root': { padding: 0 },
    '& .MuiListItemText-root': { margin: 0 },
    maxHeight: '200px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px', // Width of vertical scrollbar
      height: '6px', // Height of horizontal scrollbar
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255, 186, 0, 0.8)', // Thumb color
      borderRadius: '10px', // Thumb border radius
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(255, 186, 0, 0.1)', // Track color
    },
  },
  warningIcon: {
    padding: 4,
    borderRadius: 4,
  },
  displayWarningContainer: { color: '#ffba00' },
  listLable: {
    color: '#ffbf00',
    width: '0.5rem',
    height: '0.5rem',
  },
  collectionsGuideButtonWrap: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
      marginTop: 0,
    },
  },
  collectionsGuideButton: {
    minWidth: 160,
    '&.Mui-disabled': {
      opacity: 0.65,
    },
  },
  collectionsTabsContainer: {
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
